import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";

function CreateQuoteRow({ agents, generateNewRow }) {
  const [formData, setFormData] = useState({
    policyNumber: "",
    carrier: "",
    effectiveDate: "",
    clientFirstName: "",
    clientLastName: "",
    address: " ",
    dwelling: 0,
    structures: 0,
    persprop: 0,
    lossofuse: 0,
    liability: 0,
    medical: 0,
    deductible: 0,
    premium: "",
    declaration: "",
    mainAgent: "",
    mainAgentSplit: "",
    refAgentOne: "",
    refAgentOneSplit: "",
    refAgentTwo: "",
    refAgentTwoSplit: "",
    refAgentThree: "",
    refAgentThreeSplit: "",
    refAgentFour: "",
    refAgentFourSplit: "",
    firstName: "",
    lastName: "",
    dob: "",
    quickAddress: "",
    phone: "",
    vehicles: "",
    drivers: "",
    email: "",
    declaration1: "",
    declaration2: "",
    declaration3: "",
    targetPremium: "",
    docName: "",
    document: "",
    docName1: "",
    document1: "",
    docName2: "",
    document2: "",
    docName3: "",
    document3: "",
    targetDate: "",
    notes: ""
  });

  useEffect(() => {}, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const getBase64 = (file, callBack) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      callBack(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      return error;
    };
  };

  const fileSelectedHandler = (event) => {
    event.preventDefault();
    console.log(event.target.files);
    setFormData((prev) => ({
      ...prev,
      docName: event.target.files[0].name
    }));
    if (event.target.files[0]) {
      getBase64(event.target.files[0], (res) => {
        console.log(res);
        setFormData((prev) => ({
          ...prev,
          document: res
        }));
      });
    }
  };

  const handleQuoteCreate = (event) => {
    event.preventDefault();

    const quoteInformation = {
      quickAddress: formData.quickAddress,
      firstName: formData.firstName,
      lastName: formData.lastName,
      clientID: -1,
      phone: formData.phone,
      vehicles: formData.vehicles,
      drivers: formData.drivers,
      email: formData.email,
      mainAgent: formData.mainAgent,
      mainAgentSplit: formData.mainAgentSplit,
      refAgentOne: formData.refAgentOne,
      refAgentOneSplit: formData.mainAgentSplit,
      refAgentTwo: formData.refAgentTwo,
      refAgentTwoSplit: formData.mainAgentSplit,
      declaration1: formData.declaration1,
      declaration2: formData.declaration2,
      declaration3: formData.declaration3,
      targetPremium: formData.targetPremium,
      targetDate: formData.targetDate,
      convertedToClient: false,
      convertedToClientID: "",
      notes: formData.notes
    };

    console.log(quoteInformation);

    API.saveQuote(quoteInformation)
      .then((res) => {
        console.log("Saved Quote!");
        alert("Saved Quote!");
        cogoToast.success("Saved New Quote!");

        console.log(res.data);
        generateNewRow(res.data);

        if (formData.document.length > 0) {
          API.createDocumentForQuote(res.data._id, {
            docName: formData.docName,
            document: formData.document,
            policyid: res.data._id,
            type: "quote"
          });
        }

        if (formData.document1.length > 0) {
          API.createDocumentForQuote1(res.data._id, {
            docName: formData.docName1,
            document: formData.document1,
            policyid: res.data._id,
            type: "quote"
          });
        }

        if (formData.document2.length > 0) {
          API.createDocumentForQuote2(res.data._id, {
            docName: formData.docName2,
            document: formData.document2,
            policyid: res.data._id,
            type: "quote"
          });
        }

        if (formData.document3.length > 0) {
          API.createDocumentForQuote3(res.data._id, {
            docName: formData.docName3,
            document: formData.document3,
            policyid: res.data._id,
            type: "quote"
          });
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <tr>
      <td style={{ midWidth: "100px" }}>
        <input
          type="text"
          style={{ minWidth: "80px", width: "100%" }}
          value={formData.firstName}
          onChange={handleInputChange}
          name="firstName"
          placeholder="First"
        />
        <input
          type="text"
          style={{ minWidth: "80px", width: "100%" }}
          value={formData.lastName}
          onChange={handleInputChange}
          name="lastName"
          placeholder="Last"
        />
      </td>
      <td style={{ midWidth: "100px" }}>
        <input
          type="date"
          style={{ width: "200px" }}
          value={formData.targetDate}
          onChange={handleInputChange}
          name="targetDate"
        />
      </td>
      <td style={{ midWidth: "100px" }}>
        <input
          type="text"
          style={{ width: "300px" }}
          value={formData.quickAddress}
          onChange={handleInputChange}
          name="quickAddress"
          placeholder="Address"
        />
      </td>
      <td style={{ midWidth: "100px" }}>
        <input
          type="text"
          style={{ width: "150px" }}
          value={formData.phone}
          onChange={handleInputChange}
          name="phone"
          placeholder="Phone #"
        />
      </td>
      <td style={{ midWidth: "100px" }}>
        <input
          style={{ width: "250px" }}
          type="text"
          value={formData.notes}
          onChange={handleInputChange}
          name="notes"
          placeholder="Notes"
        />
      </td>
      <td style={{ midWidth: "100px" }}>
        {agents ? (
          <div>
            <select
              style={{ width: "150px" }}
              id="protegeDropMenu"
              value={formData.mainAgent}
              onChange={handleInputChange}
              name="mainAgent"
            >
              <option value="">--Select Main Agent--</option>
              {agents.map((agent) => (
                <option key={agent._id} value={agent._id}>
                  {agent.firstName} {agent.lastName}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div>No agents yet</div>
        )}
      </td>
      <td style={{ midWidth: "100px" }}>
        {agents ? (
          <div>
            <select
              style={{ width: "150px" }}
              id="protegeDropMenu"
              value={formData.refAgentOne}
              onChange={handleInputChange}
              name="refAgentOne"
            >
              <option value="">--Select Referral Agent--</option>
              {agents.map((agent) => (
                <option key={agent._id} value={agent._id}>
                  {agent.firstName} {agent.lastName}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div>No agents yet</div>
        )}
      </td>
      <td style={{ midWidth: "100px" }}>
        {agents ? (
          <div>
            <select
              style={{ width: "150px" }}
              id="protegeDropMenu"
              value={formData.refAgentTwo}
              onChange={handleInputChange}
              name="refAgentTwo"
            >
              <option value="">--Select Referral Agent--</option>
              {agents.map((agent) => (
                <option key={agent._id} value={agent._id}>
                  {agent.firstName} {agent.lastName}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div>No agents yet</div>
        )}
      </td>
      <td style={{ midWidth: "100px" }}>
        <input
          style={{ width: "100px" }}
          type="number"
          value={formData.mainAgentSplit}
          name="mainAgentSplit"
          placeholder="Split"
          onChange={handleInputChange}
        />
      </td>
      <td style={{ midWidth: "100px" }}>
        <input
          style={{ width: "100px" }}
          type="text"
          value={formData.email}
          onChange={handleInputChange}
          name="email"
          placeholder="e-mail"
        />
      </td>
      <td>
        <button className="btn-success btn" onClick={handleQuoteCreate}>
          Create
        </button>
      </td>
      <td>
        <p>Declarations</p>
        <input name="document" type="file" onChange={fileSelectedHandler} />
      </td>
    </tr>
  );
}

export default CreateQuoteRow;
